<template>
    <div class="row text-left align-items-center col-12 my-1 ">
        <div class="col-2 col-md-auto text-left toggle-item font-24">
            <i
                class="fal fa-toggle-on text-success"
                v-if="isVisible == true"
                @click="isVisible = false"
            ></i>
            <i
                class="fal fa-toggle-off opacity-50"
                v-if="
                    isVisible == false ||
                    isVisible == null
                "
                @click="isVisible = true"
            ></i>
        </div>

        <div class=" my-2 pl-0">
            <label class="mb-0">{{ label }}</label>
        </div>
</div>
</template>
<script>
export default {
    name: "checkBox",
	data() {
		return {
            isVisible: false,
        }
    },
    props: {
        label: {
            type: String,
            required: false,

        },
        visible: {
            required: true,
        },
    },
    created() {
        this.isVisible = !! this.visible;
    },
	watch: {
        isVisible(){
            this.$emit('onCheck',this.isVisible);
        },
        visible() {
            this.isVisible = !! this.visible;
        }
    }
};
</script>


// WEBPACK FOOTER //
// src/components/atoms/checkBox.vue